import { z } from 'zod';
import { CreateLabelReturnOrderSchema } from '@/services/models/Returns/order/schemas';
import { LabelService } from './LabelService';
import type { IReturnLabel } from './IReturnLabel';
import type { IReturnLabelParams } from './IReturnLabelParams';
import type { IReprintLabelParams } from './IReprintLabelParams';

/** Zod schema for {@link IReturnLabelParams}. */
export const ReturnLabelParamsSchema = z.object({
  order: CreateLabelReturnOrderSchema,
  isQRCode: z.boolean(),
  labelService: z.nativeEnum(LabelService)
}) satisfies z.ZodType<IReturnLabelParams>;

/** Zod schema for {@link IReturnLabel}. */
export const ReturnLabelSchema = z.object({
  label: z.string(),
  transactionID: z.string(),
  shipmentID: z.string(),
  reprintURL: z.string(),
  labelService: z.nativeEnum(LabelService)
}) satisfies z.ZodType<IReturnLabel>;

/** Zod schema for {@link IReprintLabelParams}. */
export const ReprintLabelParamsSchema = z.object({
  transactionID: z.string(),
  shipmentID: z.string(),
  isQRCode: z.boolean().optional().default(false),
  labelService: z.nativeEnum(LabelService)
}) satisfies z.ZodType<IReprintLabelParams>;
